import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSize, IconType } from '../icon/icon';
import './playerIcon.scss';
import { OverlayTrigger, Popover } from 'react-bootstrap';

/**
 * Badge with optional icon. It can be used to list items or to define tags.
 */
const PlayerIcon = (props) => {
  const defaultColor="#6cc24a";
  const greenColor="#6cc24a";
  const orangeColor="#d8783f";
  const blackColor="#444444";
  const {
    className,value
  } = props;

  const [icon,setIcon] =useState(IconType.STOP);
  const [color,setColor] =useState(defaultColor);
  const [description,setDescription] =useState("");

  useEffect(() => {
    // console.log("vvv",JSON.parse(value));
    let valueObj=JSON.parse(value)
    switch(valueObj["status"]){
      case "finished":
        setIcon(IconType.FINISHED);
      break;
      case "pause":
        setIcon(IconType.PAUSE);
      break;
      case "play":
        setIcon(IconType.PLAY);
      break;
      case "stop":
        setIcon(IconType.STOP);
    }
    setColor(valueObj["color"]);
    setDescription(valueObj["description"]);
  }, [value]);


  return (
      <OverlayTrigger
        trigger={['hover', 'focus', 'click']}
        placement={"top"}
        overlay={(
          <Popover id="tooltip-left">
            <Popover.Content>
              {description}
            </Popover.Content>
          </Popover>
        )}
      >
        <div><Icon
            icon={icon}
            iconColor={color}
            iconSize={IconSize.DOUBLE}
        /></div>
    </OverlayTrigger>
  );
};

PlayerIcon.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  color:PropTypes.string,


};

PlayerIcon.defaultProps = {
  value: 'not-defined',
  color:''
};

export default PlayerIcon;
